import img from '../../../images/projects/pony.png'
import { useEffect } from 'react';

import paths from '../../../config/paths'

export default function MyLittlePony({ visited }) {

    useEffect(() => {
        visited();
    }, []);

    return(
        <main className="relative flex flex-col justify-evenly">
            <div className='video'>
                <img src={img}></img>
            </div>
            <h2 className='title'>My Little Pony</h2>
            <p className='content'>Ce projet est le premier que j'ai fait sans frameworks suite à un petit challenge qu'on s'était donné entre apprenants. Le but était de créer un site pour un groupe de musique réel ou fictif. Attention les yeux !</p>
            <p className='skills'>HTML/CSS | Javascript</p>
            <div className='project-button'>
                <a className='website' target="_blank" href="https://coussecousse.github.io/projet-secret/">Le site</a>
                <a className='github' target="_blank" href="https://github.com/Coussecousse/projet-secret"><i className="fa-brands fa-github"></i>Github</a>
            </div>
            <div className='project-button big-buttons'>
                <a href={paths.MEMORY} className='backProject'><i className="fa-solid fa-arrow-left mr-2"></i>Précédent projet</a>
                <a href={paths.PROJECTS} className='backProject'><i className="fa-solid fa-arrow-left mr-2"></i>Revenir aux projets</a>
                <a href={paths.CODEPEN} className='backProject'>Prochain projet<i className="fa-solid fa-arrow-right ml-2"></i></a>
            </div>
        </main>
    )
}